/* eslint-disable react/forbid-prop-types */
import { Field, Form, Formik } from 'formik';
import { InputField, TextAreaField } from 'Modules/Formik';
import { object } from 'prop-types';
import React, { forwardRef } from 'react';

import css from './MemoContent.less';
import { MemoContentSchema } from './validate';

const MemoContent = forwardRef(({ initialValues }, ref) => (
  <div className={css.content}>
    <Formik
      initialValues={initialValues}
      onSubmit={() => true}
      innerRef={ref}
      validationSchema={MemoContentSchema}>
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <div className={css.reason}>
            <Field errorInline label="Subject" name="subject" component={InputField} />
          </div>
          <div style={{ marginTop: 16 }}>
            <Field
              style={{ flex: 1 }}
              label="Reason for Referral"
              name="content"
              errorInline
              component={TextAreaField}
              rows={6}
            />
          </div>
        </Form>
      )}
    </Formik>
  </div>
));

MemoContent.propTypes = {
  initialValues: object.isRequired,
};

export default MemoContent;
